import React from "react";
import { connect } from "react-redux";
import { Popup, Button, TextBox } from "devextreme-react";
import ListaUsuarios from "./listaUsuarios";
import Stepper from "react-stepper-horizontal";
import { doMultipleUserSubscription, doExternalWorkSuscription, doExternaMassiveSuscrition, setSearchText } from "../actions";
import { openCloseToast } from "../../../../../Global/actions";

//

import ListaNotificaciones from "./listaNotificaciones";

import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import validacion from "../../../../../../helpers/validaciones";

class ModalSuscribirTrabajadores extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      disableNext: true,
      selectedUsers: null,
      avaliableUsers: [],
      step: 0,
      selectedNotifications: null,
      fromOneValid: false,
      personalData: {
        Name: null,
        LastName: null,
        Mail: null,
        CellPhone: null,
      },
      validPersonalData: {
        isValidName: true,
        isValidLastName: true,
        isValidMail: true,
        isValidCellPhone: true,
      },
    };
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.isOpen && this.props.isOpen) {
      const {
        usuarios,
        selectedNotification,
        typeUserRelationFilter,
      } = this.props;


      let suscribedUsers = [];
      let users = usuarios;

      if (selectedNotification && selectedNotification.Subscriptors) {
        suscribedUsers = selectedNotification.Subscriptors;
        if (typeUserRelationFilter === "INT") {
          users = usuarios.filter((e) => suscribedUsers.filter((sub) => sub.EmployeeRut === e.Rut).length === 0);
          this.setState({ avaliableUsers: users });
        }
        // if (typeUserRelationFilter === "EXT") {
        //   users = usuarios.filter((e) => suscribedUsers.filter((sub) => sub.Id === e.Id).length === 0);
        //   this.setState({ avaliableUsers: users });
        // }
      }
    }
  }

  handleUserSelect = (e) => {
    const selectedItems = e.selectedRowsData;
    this.setState({ selectedUsers: selectedItems, disableNext: !selectedItems.length });
  }

  handleSuscribir = () => {
    if (this.props.typeUserRelationFilter === "INT") {
      const Data = {
        NotificationGroupId: this.props.selectedNotification.NotificationGroupId,
        CompanyRut: this.props.companyId,
        BranchId: this.props.sucursalId,
        EmployeesRut: this.state.selectedUsers.map((e) => e.Rut),
      };
      this.props.dispatch(doMultipleUserSubscription(this.props.selectedNotification.NotificationGroupName, Data, this.handleClose));
    }
    if (this.props.typeUserRelationFilter === "EXT") {
      if (this.state.validPersonalData.isValidCellPhone === true && this.state.validPersonalData.isValidMail === true) {
        const Data = {};
        Data.NotificationGroupId = this.props.selectedNotification.NotificationGroupId;
        Data.CompanyRut = this.props.companyId;
        Data.CellPhone = this.state.personalData.CellPhone;
        Data.Email = this.state.personalData.Mail;
        Data.LastName = this.state.personalData.LastName;
        Data.Name = this.state.personalData.Name;
        Data.BranchId = this.props.sucursalId;
        this.props.dispatch(doExternalWorkSuscription(Data, this.handleClose));
      } else {
        let msje = "";
        if (this.state.validPersonalData.isValidCellPhone === false && this.state.validPersonalData.isValidMail === false) {
          msje = "Correo y número celular ya estan ingresado, porfavor ingrese unos nuevos";
        } else {
          if (this.state.validPersonalData.isValidCellPhone === false) {
            msje = "Número celular ya esta ingresado, porfavor ingrese unos nuevos";
          }
          if (this.state.validPersonalData.isValidMail === false) {
            msje = "Correo ya esta ingresado, porfavor ingrese uno nuevo";
          }
        }
        this.setState({ step: 0, disableNext: false });
        this.props.dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: msje,
          typeStyle: "warning",
          displayTime: 5000,
        }));
      }
    }
  }
  handleSelectNotification = (e) => {
    const selectedItems = e.component.option("selectedItems");
    this.setState({ selectedNotifications: selectedItems, disableNext: !selectedItems.length });
  }
  handleChange = (e) => {
    const ident = (typeof e === "object") ? e.element.id : "";
    const validationList = this.props.listValidacionUsuarios;
    let errorTxt = "";
    const personalData = Object.assign({}, this.state.personalData);
    const validPersonalData = Object.assign({}, this.state.validPersonalData);
    switch (ident) {
      case "Name": {
        validPersonalData.isValidName = true;
        if (e.value === "") {
          errorTxt = "Dato Requerido";
          validPersonalData.isValidName = false;
        }
        e.component.option({
          validationError: { message: errorTxt },
          isValid: validPersonalData.isValidName,
        });
        personalData.Name = e.value;

        break;
      }
      case "LastName": {
        validPersonalData.isValidLastName = true;
        if (e.value === "") {
          errorTxt = "Dato Requerido";
          validPersonalData.isValidLastName = false;
        }
        e.component.option({
          validationError: { message: errorTxt },
          isValid: validPersonalData.isValidLastName,
        });
        personalData.LastName = e.value;
        break;
      }
      case "Mail": {
        validPersonalData.isValidMail = true;
        if (!validacion.validarEmail(e.value)) {
          errorTxt = "Formato correo electrónico inválido";
          validPersonalData.isValidMail = false;
        } else {
          validPersonalData.isValidMail = true;
        }

        const existIntero = validationList.filter((r) => r.Email === e.value);
        const existExterno = this.props.usuarios.filter((r) => r.Email === e.value);

        if (existIntero.length > 0 || existExterno.length > 0) {
          errorTxt = "Correo electrónico ya ingresado";
          validPersonalData.isValidMail = false;
        }

        e.component.option({
          validationError: { message: errorTxt },
          isValid: validPersonalData.isValidMail,
        });

        personalData.Mail = e.value;

        break;
      }
      case "CellPhone": {
        validPersonalData.isValidCellPhone = true;
        personalData.CellPhone = e.value;
        if (e.value.length > 0) {
          if (!validacion.validateCellPhone(`+569${e.value}`)) {
            errorTxt = "Formato télefono inválido";
            validPersonalData.isValidCellPhone = false;
          } else {
            validPersonalData.isValidCellPhone = true;
          }
        }
        const existIntero = validationList.filter((r) => r.CellPhone === e.value);
        const existExterno = this.props.usuarios.filter((r) => r.CellPhone === e.value);
        if (existIntero.length > 0 || existExterno.length > 0) {
          errorTxt = "télefono ya ingresado";
          validPersonalData.isValidCellPhone = false;
        }

        e.component.option({
          validationError: { message: errorTxt },
          isValid: validPersonalData.isValidCellPhone,
        });

        break;
      }

      default:
        break;
    }


    this.setState({
      personalData,
      validPersonalData,
      fromOneValid: !!(((validPersonalData.isValidMail && personalData.Mail) &&
                        (validPersonalData.isValidCellPhone && personalData.CellPhone) &&
                        (validPersonalData.isValidName && personalData.Name) &&
                        (validPersonalData.isValidLastName && personalData.LastName))),
    });
  }

  handleNextStep = () => {
    if (this.state.validPersonalData.isValidCellPhone === true && this.state.validPersonalData.isValidMail === true) {
      this.setState({ step: 1, disableNext: true });
    } else {
      let msje = "";
      if (this.state.validPersonalData.isValidCellPhone === false && this.state.validPersonalData.isValidMail === false) {
        msje = "Correo y número celular ya estan ingresado, porfavor ingrese unos nuevos";
      } else {
        if (this.state.validPersonalData.isValidCellPhone === false) {
          msje = "Número celular ya esta ingresado, porfavor ingrese unos nuevos";
        }
        if (this.state.validPersonalData.isValidMail === false) {
          msje = "Correo ya esta ingresado, porfavor ingrese uno nuevo";
        }
      }
      this.setState({ step: 0, disableNext: false });
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: msje,
        typeStyle: "warning",
        displayTime: 5000,
      }));
    }
  }

  handleClose = () => {
    this.setState({
      disableNext: true,
      selectedUsers: null,
      avaliableUsers: [],
      step: 0,
      selectedNotifications: null,
      fromOneValid: false,
      personalData: {
        Name: null,
        LastName: null,
        Mail: null,
        CellPhone: "",
      },
      validPersonalData: {
        isValidName: true,
        isValidLastName: true,
        isValidMail: true,
        isValidCellPhone: true,
      },
    });

    this.props.dispatch(setSearchText(null));
    this.setState({ disableNext: true, selectedUsers: [] });
    this.props.onClose();
  }
  handleSuscribe = () => {
    const Data = {
      NotificationGroupIds: this.state.selectedNotifications.map((e) => e.NotificationGroupId),
      BranchId: this.props.sucursalId,
      CompanyRut: this.props.companyId,
      Name: this.state.personalData.Name,
      LastName: this.state.personalData.LastName,
      Email: this.state.personalData.Mail,
      CellPhone: this.state.personalData.CellPhone,
    };

    this.props.dispatch(doExternaMassiveSuscrition(Data, this.handleClose));
  }


  render() {
    const {
      isOpen,
    } = this.props;


    return (


      <Popup
        visible={isOpen}
        title={this.props.typeUserRelationFilter !== "EXT" ? "Suscribir trabajadores" : "Suscribir trabajador externo"}
        showTitle
        maxWidth={600}
        height={550}
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
      >
        <div>
          {this.props.isLoading && <LoadingOverlay />}
          {
            this.props.typeUserRelationFilter === "INT" && (
              <React.Fragment>
                <ListaUsuarios
                  onSelect={this.handleUserSelect}
                  usuarios={this.state.avaliableUsers}
                  selected={this.state.selectedUsers}
                  typeUserRelationFilter={this.props.typeUserRelationFilter}
                  height={356}
                  hideDate

                />
                <div className="button-row">
                  <div>
                    <Button
                      onClick={this.handleClose}
                      text="Cancelar"
                    />
                  </div>
                  <div>
                    <Button
                      onClick={this.handleSuscribir}
                      type="success"
                      disabled={this.state.disableNext}
                      text="Suscribir"
                    />
                  </div>
                </div>
              </React.Fragment>

            )
          }
          {
            this.props.typeUserRelationFilter === "EXT" && (
              <React.Fragment>
                {this.props.availableListUser === true && (
                  <React.Fragment>
                    <div className="row">

                      <div className="col-12">

                        <div className="field-newDenuncia">
                          <h3><p>Nombre<span className="label-red-requerido"> *</span> </p></h3>
                          <TextBox
                            id="Name"
                            value={this.state.personalData.Name}
                            valueChangeEvent="focusout"
                            onValueChanged={this.handleChange}
                            isValid={this.state.validPersonalData.isValidName}
                          />

                        </div>
                        <div className="field-newDenuncia">
                          <h3><p>Apellido<span className="label-red-requerido"> *</span> </p></h3>
                          <TextBox
                            id="LastName"
                            value={this.state.personalData.LastName}
                            valueChangeEvent="focusout"
                            onValueChanged={this.handleChange}
                            isValid={this.state.validPersonalData.isValidLastName}
                          />

                        </div>
                        <div className="field-newDenuncia">
                          <h3><p>Mail<span className="label-red-requerido"> *</span> </p></h3>
                          <TextBox
                            id="Mail"
                            value={this.state.personalData.Mail}
                            onValueChanged={this.handleChange}
                            valueChangeEvent="focusout"
                            isValid={this.state.validPersonalData.isValidMail}
                          />


                        </div>
                        <div className="field-newDenuncia">
                          <h3><p>Teléfono <span className="label-red-requerido"> *</span></p></h3>
                          <TextBox
                            id="CellPhone"
                            value={this.state.personalData.CellPhone}
                            onValueChanged={this.handleChange}
                            valueChangeEvent="focusout"
                            isValid={this.state.validPersonalData.isValidCellPhone}
                            mask="+56\999999999"
                            // maskRules={{ f: () => this.state.validPersonalData.isValidCellPhone }}
                          />

                        </div>


                      </div>
                    </div>
                    <div className="button-row">
                      <div>
                        <Button
                          onClick={this.handleClose}
                          text="Cancelar"
                        />
                      </div>
                      <div>
                        <Button
                          onClick={this.handleSuscribir}
                          type="success"
                          disabled={!(this.state.fromOneValid)}
                          text="Suscribir"
                        />
                      </div>
                    </div>


                  </React.Fragment>
                )}
                {this.props.availableListUser === false && (
                  <React.Fragment>
                    <Stepper
                      className="stepper-registro"
                      activeStep={this.state.step}
                      circleTop={15}
                      activeColor="#00963a"
                      completeColor="#0C652F"
                      steps={[
                        { title: "Datos del trabajador" },
                        { title: "Seleccionar notificaciones" },
                      ]}
                    />
                    {this.state.step === 0 && (
                      <div className="row">

                        <div className="col-12">

                          <div className="field-newDenuncia">
                            <h3><p>Nombre <span className="label-red-requerido"> *</span> </p></h3>
                            <TextBox
                              id="Name"
                              value={this.state.personalData.Name}
                              valueChangeEvent="focusout"
                              onValueChanged={this.handleChange}
                              isValid={this.state.validPersonalData.isValidName}
                            />

                          </div>
                          <div className="field-newDenuncia">
                            <h3><p>Apellido<span className="label-red-requerido"> *</span> </p></h3>
                            <TextBox
                              id="LastName"
                              value={this.state.personalData.LastName}
                              valueChangeEvent="focusout"
                              onValueChanged={this.handleChange}
                              isValid={this.state.validPersonalData.isValidLastName}
                            />
                          </div>
                          <div className="field-newDenuncia">
                            <h3><p>Mail<span className="label-red-requerido"> *</span> </p></h3>
                            <TextBox
                              id="Mail"
                              value={this.state.personalData.Mail}
                              onValueChanged={this.handleChange}
                              valueChangeEvent="focusout"
                              isValid={this.state.validPersonalData.isValidMail}
                            />
                          </div>
                          <div className="field-newDenuncia">
                            <h3><p>Teléfono<span className="label-red-requerido"> *</span></p></h3>
                            <TextBox
                              id="CellPhone"
                              value={this.state.personalData.CellPhone}
                              onValueChanged={this.handleChange}
                              valueChangeEvent="focusout"
                              isValid={this.state.validPersonalData.isValidCellPhone}
                              mask="+56\999999999"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.step === 1 && (
                      <React.Fragment>
                        <div className="modalSuscripcionWrapper">
                          <ListaNotificaciones
                            data={this.props.notificaciones}
                            selected={this.state.selectedNotifications}
                            onSelection={this.handleSelectNotification}
                            selectionMode="multiple"
                            showCheck
                            hideNumbers
                            hideDetails
                          />
                        </div>

                      </React.Fragment>
                    )}
                    <div className="button-row">
                      <div>
                        <Button
                          onClick={this.handleClose}
                          text="Cancelar"
                        />
                      </div>
                      <div>
                        {this.state.step === 0 && (
                          <Button
                            onClick={this.handleNextStep}
                            type="success"
                            disabled={!(this.state.fromOneValid)}
                            text="Siguiente"
                          />
                        )}
                        {this.state.step === 1 && (
                          <Button
                            onClick={this.handleSuscribe}
                            type="success"
                            disabled={this.state.disableNext}
                            text="Suscribir trabajador"
                          />
                        )}
                      </div>
                    </div>

                  </React.Fragment>
                )}


              </React.Fragment>
            )
          }


        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.notificacionesEmpresa.isLoading,
  notificaciones: state.notificacionesEmpresa.notificaciones,
  usuarios: state.notificacionesEmpresa.usuarios,
  selectedNotification: state.notificacionesEmpresa.selectedNotification,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  typeUserRelationFilter: state.notificacionesEmpresa.typeUserRelationFilter,
  availableListUser: state.notificacionesEmpresa.availableListUser,
  listValidacionUsuarios: state.notificacionesEmpresa.listValidacionUsuarios,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSuscribirTrabajadores);
